import React from 'react';

import {MAIN_SITE_ROOT} from '~/config';
import FatalErrorPage from '~/pods/site/pages/FatalErrorPage/';

export default class RouteUtils {
	static asyncComponent(getComponent) {
		return class AsyncComponent extends React.Component {
			static Component = null;
			state = {Component: AsyncComponent.Component, hasError: false};

			componentDidCatch(error, info) {
				this.setState({hasError: true, error, info});
			}

			componentDidMount() {
				if (!this.state.Component) {
					getComponent().then(({default: Component}) => {
						AsyncComponent.Component = Component;
						this.setState({Component});
					});
				}
			}

			render() {
				if (this.state.hasError) {
					return <FatalErrorPage error={this.state.error} info={this.state.info} />;
				}
				const {Component} = this.state;
				if (Component) {
					return <Component {...this.props} />;
				}
				return null;
			}
		};
	}

	/**
	 * Redirects a given path to the equivalent WI portal path
	 * @param {string} path
	 */
	static redirectPathToPortal(path) {
		if (process.env.NODE_ENV === 'production') {
			window.location = `${MAIN_SITE_ROOT}${path}`;
		}
	}
}
